/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { Route, Switch, useLocation, useParams } from 'react-router-dom';

import { NavPills } from '@C';
import { AssignDuty } from '@C/CashiersOnDuty/RouteComponents';
import ErrorBoundary from '@C/Error';
import { useGlobalStore } from '@stores/globalStore';
import { useShallow } from 'zustand/react/shallow';

import {
  CollectionSummary,
  CreditSaleSummary,
  Expenses,
  FuelSummary,
  LubeSummary,
  OtherIncome,
  TotalSummary,
} from './Steps';

const EndDuty = () => {
  const { setCODGrandTotal, syncCODCollectionData, codCollectionData } =
    useGlobalStore(
      useShallow((state) => ({
        setCODGrandTotal: state.setCODGrandTotal,
        syncCODCollectionData: state.syncCODCollectionData,
        codCollectionData: state.codCollectionData,
      })),
    );

  const { duty, date, mode, staff } = useParams();
  const location = useLocation();
  const isViewMode = (mode || '').includes('view-duty');
  const [dutyTimeStamp] = useState(
    () => new URLSearchParams(location.search).get('ts') || null,
  );
  const [savedEndDutyTimeStamp] = useState(
    () => new URLSearchParams(location.search).get('endTs') || null,
  );

  if (!duty || !date || !staff) return null;

  const routes = [
    {
      name: 'Fuel Sales',
      path: `/cashiers-on-duty/end-duty/${duty}/${date}/${staff}/${mode}/fuel-sales`,
    },
    {
      name: 'Lube / Products Sales',
      path: `/cashiers-on-duty/end-duty/${duty}/${date}/${staff}/${mode}/lube-sales`,
    },
    {
      name: 'Credit Sales',
      path: `/cashiers-on-duty/end-duty/${duty}/${date}/${staff}/${mode}/credit-sales`,
    },
    {
      name: 'Other Income',
      path: `/cashiers-on-duty/end-duty/${duty}/${date}/${staff}/${mode}/other-income`,
    },
    {
      name: 'Expenses',
      path: `/cashiers-on-duty/end-duty/${duty}/${date}/${staff}/${mode}/expenses`,
    },
    {
      name: 'Collection Summary',
      path: `/cashiers-on-duty/end-duty/${duty}/${date}/${staff}/${mode}/collection-summary`,
    },
  ];

  useEffect(() => {
    setCODGrandTotal(duty, staff);
    syncCODCollectionData(duty, staff);
  }, []);

  return (
    <>
      <ErrorBoundary>
        <NavPills routes={routes} />
        <TotalSummary
          date={date}
          dutyTimeStamp={dutyTimeStamp}
          savedEndDutyTimeStamp={savedEndDutyTimeStamp}
          duty={duty}
          staff={staff}
          isViewMode={isViewMode}
        />
      </ErrorBoundary>
      <ErrorBoundary>
        <Switch>
          <Route
            exact
            path="/cashiers-on-duty/end-duty/:duty/:date/:staff/:mode/fuel-sales"
            render={(props) => (
              <FuelSummary
                {...props}
                syncCODCollectionData={syncCODCollectionData}
                isViewMode={isViewMode}
              />
            )}
          />
          <Route
            exact
            path="/cashiers-on-duty/end-duty/:duty/:date/:staff/:mode/lube-sales"
            render={(props) => (
              <LubeSummary
                {...props}
                syncCODCollectionData={syncCODCollectionData}
                isViewMode={isViewMode}
              />
            )}
          />
          <Route
            exact
            path="/cashiers-on-duty/end-duty/:duty/:date/:staff/:mode/credit-sales"
            render={(props) => (
              <CreditSaleSummary
                {...props}
                syncCODCollectionData={syncCODCollectionData}
                isViewMode={isViewMode}
              />
            )}
          />
          <Route
            exact
            path="/cashiers-on-duty/end-duty/:duty/:date/:staff/:mode/other-income"
            render={(props) => (
              <OtherIncome
                {...props}
                syncCODCollectionData={syncCODCollectionData}
                isViewMode={isViewMode}
              />
            )}
          />
          <Route
            exact
            path="/cashiers-on-duty/end-duty/:duty/:date/:staff/:mode/expenses"
            render={(props) => (
              <Expenses
                {...props}
                syncCODCollectionData={syncCODCollectionData}
                isViewMode={isViewMode}
              />
            )}
          />
          <Route
            exact
            path="/cashiers-on-duty/end-duty/:duty/:date/:staff/:mode/collection-summary"
            render={(props) => (
              <CollectionSummary
                {...props}
                syncCODCollectionData={syncCODCollectionData}
                collectionData={codCollectionData}
                isViewMode={isViewMode}
              />
            )}
          />
          <Route path="*" exact={true} component={AssignDuty} />
        </Switch>
      </ErrorBoundary>
    </>
  );
};

export { EndDuty };
